<template>
  <v-form v-model="valid" ref="form">
    <div class="display-1">{{ $t('registration.steps[1]') }}</div>
    <v-divider />
    <v-layout
      align-center
      wrap
      class="pt-1"
    >
      <!--v-flex xs12 class="pt-1">
        <v-layout>
          <v-flex shrink class="pt-1 pr-1">
            <v-icon
              x-large
              color="red"
            >
              local_hospital
            </v-icon>
          </v-flex>
          <v-flex>
            <p class="body-1">
              {{ $t('registration.waiverForm.medical_conditions') }}
            </p>
            <p class="body-2 font-italic">
              {{ $t('registration.waiverForm.medical_privacy_policy') }}
            </p>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-textarea
          v-model="medicalConditions"
          auto-grow
          outline
          clearable
          full-width
          placeholder="Allergies, asthma, required medications, etc."
          style="width: 100%"
          :rules="medicalConditionsRules"
        />
      </v-flex>
      <v-flex mt-3 xs12 style="text-align: center;">
          <img src="@/assets/dop-text-logo.jpg" style="width: 40%;"/>
      </v-flex>
      <v-flex mb-3 xs12 align-content-center>
        <ul>
            <li><p>I believe in hockey.</p></li>
            <li><p>I believe it strengthens character, fosters positive values and develops important life skills -- all of which transcend the game.</p></li>
            <li><p>I believe in hockey culture, and the power of the people involved in the game. I believe hockey is at its best when it is an enjoyable family experience, and I believe I have a role to play in this effort.</p></li>
            <li><p>I pledge to be a positive influence on my family, friends and my entire hockey community.</p></li>
        </ul>
      </v-flex-->
      <v-divider />
    </v-layout>
    <v-layout v-show="clubWaiver" wrap justify-center>
      <v-flex class="scrollable-waiver" xs12>
        <div v-html="clubWaiver"></div>
      </v-flex>
      <v-flex xs6 sm5 md4 lg3 class="pa-1">
        <v-checkbox
          :label="$t('registration.read_and_agree')"
          v-model="waiverClubChecked"
          :rules="waiverClubCheckedRules"
        ></v-checkbox>
      </v-flex>
      <v-flex xs6 sm5 md4 lg3 class="pa-1">
        <v-text-field
          :label="$t('registration.initials')"
          v-model="waiverClubInitials"
          :rules="waiverClubInitialsRules"
          box
          required
          @blur="waiverClubInitials = waiverClubInitials.toUpperCase()"
        />
      </v-flex>
    </v-layout>
    <v-layout v-show="leagueWaiver" wrap justify-center>
      <v-spacer />
      <v-flex class="scrollable-waiver" xs12>
        {{ leagueWaiver }}
      </v-flex>
      <v-flex xs6 sm5 md4 lg3 class="pa-1">
        <v-checkbox
          :label="$t('registration.read_and_agree')"
          v-model="waiverLeagueChecked"
          :rules="waiverLeagueCheckedRules"
        ></v-checkbox>
      </v-flex>
      <v-flex xs6 sm5 md4 lg3 class="pa-1">
        <v-text-field
          :label="$t('registration.initials')"
          v-model="waiverLeagueInitials"
          :rules="waiverLeagueInitialsRules"
          box
          required
          @blur="waiverLeagueInitials = waiverLeagueInitials.toUpperCase()"
        />
      </v-flex>
    </v-layout>
    <!--v-layout justify-center wrap  px-3 mb-2>
      <v-flex xs12>
        <span class="subheading">Please indicate what information you would like to receive:</span>
      </v-flex>
      <v-flex xs12>
        <v-checkbox
          hide-details
          label="Maple Leaf Sports & Entertainment Partnership information, offers and promotions "
          v-model="optInMarketing"
        />
      </v-flex>
      <v-flex>
        <v-checkbox
          hide-details
          label="Playground Pros newsletter"
          v-model="optInPlaygroundPros"
        />
      </v-flex>
    </v-layout-->
  </v-form>
</template>

<script>
export default {
  name: 'WaiversReview',
  data () {
    return {
      valid: true,
      waiverClubChecked: false,
      waiverClubInitials: '',
      waiverLeagueChecked: false,
      waiverLeagueInitials: '',
      medicalConditions: '',
      waiverClubCheckedRules: [ (v) => this.hasClubWaiver ? v || this.$t('validation.agreementRequired') : true ],
      waiverClubInitialsRules: [ (v) => this.hasClubWaiver ? !!v || this.$t('validation.initialsRequired') : true],
      waiverLeagueCheckedRules: [ (v) => this.hasLeagueWaver ? v || this.$t('validation.agreementRequired') : true ],
      waiverLeagueInitialsRules: [ (v) => this.hasLeagueWaiver ? !!v || this.$t('validation.initialsRequired') : true ],
      medicalConditionsRules: [ ]
    }
  },
  computed: {
    clubWaiver() {
      return this.$store.state.team['waiver']
    },
    leagueWaiver() {
      return this.$store.state.team['waiver-youth']
    },
    hasLeagueWaiver() {
      return !!this.$store.state.team['waiver-youth']
    },
    hasClubWaiver() {
      return !!this.$store.state.team['waiver']
    }
  },
  methods: {
    isValid() {
      if (this.$refs.form.validate()) {
        const registration = {
          'email-official-checked': 0,
          'email-offers-checked': 0,
          'email-local-checked': 0,
          'email-official-checked-ca': 0,
          'email-offers-checked-ca': 0,
          'email-local-checked-ca': 0,
          'liability-checked': this.waiverClubChecked ? 1 : 0,
          'liability-initials': this.waiverClubInitials,
          'liability-youth-checked': this.hasLeagueWaiver && this.waiverLeagueChecked ? 1 : 0,
          'liability-youth-initials': this.hasLeagueWaiver ? this.waiverLeagueInitials : null,
          'medical_information': this.medicalConditions
        }
        this.$store.commit('updateCurrentRegistration', registration)
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.scrollable-waiver {
  border: 2px inset #ccc;
  background-color: #fefefe;
  padding: 3px;
  min-height: 10vh;
  max-height: 50vh;
  overflow-y: scroll;
}

p {
  margin-bottom: .2rem;
}
</style>